const CORES = {
  verde: "bg-emerald-50 text-emerald-700",
  azul: "bg-blue-50 text-blue-700",
  dourado: "bg-amber-50 text-amber-700",
  vermelho: "bg-red-50 text-red-700",
  roxo: "bg-purple-50 text-purple-700",
  cinza: "bg-gray-100 text-gray-700",
};

/**
 * Tile de indicador (KPI) usado em grades no topo dos relatórios.
 */
const CartaoEstatistica = ({ icone: Icone, rotulo, valor, subvalor, cor = "verde", onClick }) => (
  <div
    onClick={onClick}
    className={`bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3 ${
      onClick ? "cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all" : ""
    }`}
  >
    {Icone && (
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${CORES[cor] || CORES.verde}`}>
        <Icone size={18} />
      </div>
    )}
    <div className="min-w-0">
      <p className="text-lg font-bold text-gray-800 leading-tight truncate">
        {valor}
        {subvalor && <span className="text-xs font-medium text-gray-400 ml-1">{subvalor}</span>}
      </p>
      <p className="text-xs text-gray-500 truncate">{rotulo}</p>
    </div>
  </div>
);

export default CartaoEstatistica;
